import {openPanelInModal} from "@Components/modal-container/modal-container-reducer";
import {MODALS_IDS} from "@Components/modal-container";
import type {PersonaPanelProps} from "@Panels/persona-panel/persona-panel.types";

export const openPersonaModal = (props: PersonaPanelProps): void => {
    window.PMW.redux.store.dispatch(openPanelInModal({
        modalId: MODALS_IDS.PERSONA_MODAL,
        panelProps: props
    }));
}